import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { FhtLeancloudCustomMessageType, shouldHandleFhtChatId } from "../common/types";
import { FHTChatId } from "../common/FHTChatId";
import { getChatIdFromConversation } from "@/common/convUtils";
import ChatMessageDto from "../models/ChatMessageDto";
import ImageChatMessageDto from "../models/messages/ImageChatMessageDto";
import { TextChatMessageDto } from "../models/messages/TextChatMessageDto";
import { MessageIOType, FHTDeviceType } from "../models/MessageTypes";
import { assert } from "../common/assert";
import RichCustomChatMessageDto from "@/models/messages/RichCustomChatMessageDto";
import { Realtime, Event, TextMessage, ErrorCode } from "leancloud-realtime";
import { ImageMessage, TypedMessagesPlugin } from "leancloud-realtime-plugin-typed-messages";
import AV from "leancloud-storage";
import { CustomMessagesPlugin } from "./customMessagesPlugin";
import { convertToChatMessage } from "./messageConverter";
import CustomBizEmojiMessage from "./customMessagesPlugin/CustomBizEmojiMessage";
import { getImageSize } from "@/pages/base/imageUtils";
import { fhtCommonEnv, IS_PROD } from "../common/fhtGlobalEnv";
import { isValidConvId } from "@/common/clientIdUtils";
import { loadContactPersistedContactInfoFromStorage } from "@/store/persistedContactIds";
import { formatImageUrl } from "@/common/utils";
import { PublicApiApi } from "@/apis/api/PublicApiApi";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
import { NotificationContentPartTypeEnum } from "@/apis/model/NotificationContentPartTypeEnum";
var FhtAppErrorCode;

(function (FhtAppErrorCode) {
  FhtAppErrorCode[FhtAppErrorCode["FHT_BLOCKED_ERROR_CODE"] = 36001] = "FHT_BLOCKED_ERROR_CODE";
  FhtAppErrorCode[FhtAppErrorCode["FHT_CUSTOM_VALIDATION_ERROR_CODE"] = 36002] = "FHT_CUSTOM_VALIDATION_ERROR_CODE";
  FhtAppErrorCode[FhtAppErrorCode["FHT_MESSAGE_LIMIT_REACHED_ERROR_CODE"] = 36003] = "FHT_MESSAGE_LIMIT_REACHED_ERROR_CODE";
  FhtAppErrorCode[FhtAppErrorCode["FHT_TEMPORARY_CHAT_DISABLED_ERROR_CODE"] = 36004] = "FHT_TEMPORARY_CHAT_DISABLED_ERROR_CODE";
})(FhtAppErrorCode || (FhtAppErrorCode = {}));
/**
 * The purpose of this class is to fully encapsulate Leancloud's realtime chat client
 * so that other modules do not have to interact with leancloud's realtime directly
 */


var ChatClient =
/** @class */
function () {
  function ChatClient(myself, resolver) {
    var _this = this;

    this.myself = myself;
    this.resolver = resolver;
    this._loadingIMTrigger = $.Deferred();
    assert(myself, "myself falsy");
    assert(myself.clientId, "myself.clientId falsy");
    ChatClient._instanceCount++;
    assert(ChatClient._instanceCount <= 1, "Please do not instantiate more than 1 instance of ChatClient");
    this._imP = new Promise(function (res, rej) {
      _this._loadingIMTrigger.done(function () {
        return _this.getAVIMClient(myself.clientId).then(res)["catch"](rej);
      });

      _this.shouldEagerLoadLeancloudRealtime(myself).then(function (eagerLoad) {
        if (eagerLoad) {
          _this._loadingIMTrigger.resolve();
        }
      });
    });
    this._initialTimestamp = new Date();
  }

  ChatClient.prototype.triggerLoadImIfNotAlreadyLoaded = function () {
    this._loadingIMTrigger.resolve(); //subsequent calls are no-op

  };

  ChatClient.prototype.shouldEagerLoadLeancloudRealtime = function (myself) {
    return __awaiter(this, void 0, Promise, function () {
      var persistedChatInfos;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (myself.userId) return [2
            /*return*/
            , true]; //always eager load for logged in user.

            return [4
            /*yield*/
            , loadContactPersistedContactInfoFromStorage(myself)];

          case 1:
            persistedChatInfos = _a.sent();
            return [2
            /*return*/
            , persistedChatInfos.length > 0];
          //for tourist, eager load only if there is persisted chat history
        }
      });
    });
  };

  ChatClient.prototype.getAVIMClient = function (myselfClientId) {
    return __awaiter(this, void 0, Promise, function () {
      var delta, publicApi, lcConn, realtime, im;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // see guide: https://leancloud.cn/docs/realtime-guide-beginner.html#hash817834931
            // see api doc: https://leancloud.github.io/js-realtime-sdk/docs/
            assert(myselfClientId, "myselfClientId falsy");
            delta = new Date().getTime() - this._initialTimestamp.getTime();
            !IS_PROD && console.log("%cINITIALIZING LEANCLOUD REALTIME", "background-color:blue; color: white", Math.floor(delta / 1000) + " seconds after init");
            publicApi = new PublicApiApi();
            return [4
            /*yield*/
            , publicApi.publicApiLeancloudConn({
              appVerion: fhtCommonEnv.AppVersion
            })];

          case 1:
            lcConn = _a.sent();
            AV.init({
              appId: lcConn.leancloudAppId,
              appKey: lcConn.leancloudAppKey,
              serverURL: lcConn.leancloudApiUrl
            });
            realtime = new Realtime({
              appId: lcConn.leancloudAppId,
              plugins: [TypedMessagesPlugin, CustomMessagesPlugin],
              appKey: lcConn.leancloudAppKey,
              server: lcConn.leancloudApiUrl,
              ssl: true
            });
            return [4
            /*yield*/
            , realtime.createIMClient(myselfClientId)];

          case 2:
            im = _a.sent();
            im.on(Event.CLOSE, function () {
              console.log("实时通信服务被断开！");
            });
            im.on(Event.ONLINE, function () {
              console.log("连接成功");
            });
            im.on(Event.RETRY, function () {
              console.log("重试中。。。");
            });
            im.on(Event.RECONNECT, function () {
              console.log("正在重新连接。。。");
            });
            im.on(Event.RECONNECT_ERROR, function () {
              console.log("重新连接失败！");
            });
            im.on(Event.OFFLINE, function () {
              console.log("已断开！");
            });
            im.on(Event.CONFLICT, function () {
              var args = [];

              for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
              }

              console.log("用户在其他客户端登录，当前会话已断开");
              console.log(args);
            });
            return [2
            /*return*/
            , im];
        }
      });
    });
  };

  ChatClient.prototype.onUnreadMessageCountUpdated = function (callback) {
    var _this = this;

    void this._imP.then(function (im) {
      im.on(Event.UNREAD_MESSAGES_COUNT_UPDATE, function (convs) {
        return __awaiter(_this, void 0, void 0, function () {
          var convs_1, convs_1_1, conv, convId, encodedChatId, chatId, unreadMessagesCount, m, _a, _b, e_1_1;

          var e_1, _c;

          return __generator(this, function (_d) {
            switch (_d.label) {
              case 0:
                _d.trys.push([0, 5, 6, 7]);

                convs_1 = __values(convs), convs_1_1 = convs_1.next();
                _d.label = 1;

              case 1:
                if (!!convs_1_1.done) return [3
                /*break*/
                , 4];
                conv = convs_1_1.value;
                convId = conv.id;
                assert(isValidConvId, "convId invalid: " + convId);
                assert(convId, "convId falsy");
                assert(conv, "conv is falsy!");
                assert(conv.id, "conv.id falsy");
                assert(conv.members, "conv.members falsy");
                encodedChatId = conv.get("chatId");
                if (!encodedChatId) return [3
                /*break*/
                , 3];
                assert(typeof encodedChatId === "string", "encodedChatId if exists, must be string");
                chatId = getChatIdFromConversation(conv);
                assert(chatId, "invalid encodedChatId");
                if (!(convId && shouldHandleFhtChatId(chatId))) return [3
                /*break*/
                , 3];
                unreadMessagesCount = conv.unreadMessagesCount;
                assert(typeof unreadMessagesCount === "number", "unreadMessageCount not number");
                m = conv.lastMessage ? convertToChatMessage(conv.lastMessage, this.myself) : undefined;
                _a = callback;
                _b = [m];
                return [4
                /*yield*/
                , this.resolver.getContactByFHTChatId(chatId)];

              case 2:
                _a.apply(void 0, _b.concat([_d.sent(), unreadMessagesCount]));

                _d.label = 3;

              case 3:
                convs_1_1 = convs_1.next();
                return [3
                /*break*/
                , 1];

              case 4:
                return [3
                /*break*/
                , 7];

              case 5:
                e_1_1 = _d.sent();
                e_1 = {
                  error: e_1_1
                };
                return [3
                /*break*/
                , 7];

              case 6:
                try {
                  if (convs_1_1 && !convs_1_1.done && (_c = convs_1["return"])) _c.call(convs_1);
                } finally {
                  if (e_1) throw e_1.error;
                }

                return [7
                /*endfinally*/
                ];

              case 7:
                return [2
                /*return*/
                ];
            }
          });
        });
      });
    });
  };

  ChatClient.prototype.ensureChatIdInConv = function (conv) {
    return __awaiter(this, void 0, Promise, function () {
      var CHAT_TYPE_KEY, chatType, CHAT_ID_KEY, encodedChatId, im, conv2, encodedChatId2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            //a workaround of the limitation currently exists in the system where
            //when our server creates a leancloud conversation, it is done in two steps (which means it is not atomic)
            //the first step is to create a leancloud conversation without FHTChatId
            //then using this chatId, the personal chat record is created in our server with the conversationId created above.
            //then the second step is carried out to fill up the FHTChatId in the leancloud conversation
            //but it seems that leancloud server will automatically push down the conversation down to active clients
            //when the conversation is created (our first step) and the conversation is cached with some caching strategies (only known to leancloud)
            //the second time the conversation is updated, the leancloud cache in the client will not be notified thus when we receive the message right after a new chat is created, we will most likely be passed with a conversation instance without `chatId` field in it.
            //in this case, we will retrieve conversation from leancloud without cache.
            assert(conv, "conv falsy here");
            assert(conv.id, "conv.id falsy");
            CHAT_TYPE_KEY = "chatType";
            chatType = conv.get(CHAT_TYPE_KEY);

            if (!chatType) {
              //no one of the 4 chat types we have
              return [2
              /*return*/
              , [conv, undefined]];
            }

            CHAT_ID_KEY = "chatId";
            encodedChatId = conv.get(CHAT_ID_KEY);
            if (!encodedChatId) return [3
            /*break*/
            , 1];
            assert(encodedChatId, "encodedChatId falsy");
            return [2
            /*return*/
            , [conv, FHTChatId.decode(encodedChatId)]];

          case 1:
            return [4
            /*yield*/
            , this._imP];

          case 2:
            im = _a.sent();
            return [4
            /*yield*/
            , im.getConversation(conv.id, true)];

          case 3:
            conv2 = _a.sent();
            assert(conv2, "conv2 falsy");
            encodedChatId2 = conv2.get(CHAT_ID_KEY);
            assert(encodedChatId2, "encodedChatId2 falsy even without caching for convId: " + conv.id);
            return [2
            /*return*/
            , [conv2, FHTChatId.decode(encodedChatId2)]];
        }
      });
    });
  };

  ChatClient.prototype.onReceivedMessage = function (callback) {
    var _this = this;

    this._imP.then(function (im) {
      var _onReceivedMessage = function _onReceivedMessage(msg, _conv) {
        return __awaiter(_this, void 0, void 0, function () {
          var _a, conv, chatId, convId, chatId_1, m, _b, _c;

          return __generator(this, function (_d) {
            switch (_d.label) {
              case 0:
                if (!msg) return [2
                /*return*/
                ];
                return [4
                /*yield*/
                , this.ensureChatIdInConv(_conv)];

              case 1:
                _a = __read.apply(void 0, [_d.sent(), 2]), conv = _a[0], chatId = _a[1];
                convId = msg.cid;
                assert(convId, "convId falsy");
                assert(conv.members, "conv.members falsy");
                !IS_PROD && console.log("%cReceived: ", "color:red", msg.id, msg.timestamp.getTime(), msg);
                if (!chatId) return [3
                /*break*/
                , 7];
                chatId_1 = getChatIdFromConversation(conv);
                assert(chatId_1, "invalid encodedChatId");
                if (!shouldHandleFhtChatId(chatId_1)) return [3
                /*break*/
                , 5];
                m = convertToChatMessage(msg, this.myself);
                if (!!m) return [3
                /*break*/
                , 2];
                console.warn("failed to convert chat message", msg);
                return [3
                /*break*/
                , 4];

              case 2:
                _b = callback;
                _c = [m];
                return [4
                /*yield*/
                , this.resolver.getContactByFHTChatId(chatId_1)];

              case 3:
                _b.apply(void 0, _c.concat([_d.sent()]));

                _d.label = 4;

              case 4:
                return [3
                /*break*/
                , 6];

              case 5:
                console.log("should not handle message from convId: ", convId);
                _d.label = 6;

              case 6:
                return [3
                /*break*/
                , 8];

              case 7:
                console.log("ignore chat message from convId: ", convId);
                _d.label = 8;

              case 8:
                return [2
                /*return*/
                ];
            }
          });
        });
      };

      im.on(Event.MESSAGE_RECALL, _onReceivedMessage);
      im.on(Event.MESSAGE, _onReceivedMessage);
    });
  };

  ChatClient.prototype.markContactAsRead = function (contact) {
    return __awaiter(this, void 0, Promise, function () {
      var im, conv, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this._imP];

          case 1:
            im = _a.sent();
            return [4
            /*yield*/
            , im.getConversation(contact.convId)];

          case 2:
            conv = _a.sent();
            _a.label = 3;

          case 3:
            _a.trys.push([3, 5,, 6]);

            return [4
            /*yield*/
            , conv.read()];

          case 4:
            _a.sent();

            !IS_PROD && console.log("done mark as read @markContactAsRead:", conv.id);
            return [3
            /*break*/
            , 6];

          case 5:
            err_1 = _a.sent();
            console.error("error", err_1);
            return [3
            /*break*/
            , 6];

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ChatClient.prototype.downloadHistoryMessages = function (contact) {
    return __awaiter(this, void 0, Promise, function () {
      var clientId, convId, im, conv, err_2, histories, messages, res;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.triggerLoadImIfNotAlreadyLoaded();
            assert(contact, "contact falsy");
            clientId = contact.clientId;
            assert(clientId, "clientId falsy");
            convId = contact.convId;
            assert(convId, "convId falsy");
            return [4
            /*yield*/
            , this._imP];

          case 1:
            im = _a.sent();
            return [4
            /*yield*/
            , im.getConversation(contact.convId)];

          case 2:
            conv = _a.sent();
            assert(conv, "conv falsy for convId: " + contact.convId);
            if (!conv.unreadMessagesCount) return [3
            /*break*/
            , 6]; //TODO, this might silently fail at times

            !IS_PROD && console.log("%c mark all as read: " + conv.id, "color: red;");
            _a.label = 3;

          case 3:
            _a.trys.push([3, 5,, 6]);

            return [4
            /*yield*/
            , conv.read()];

          case 4:
            _a.sent(); //mark this chat as read,


            !IS_PROD && console.log("done mark as read:", conv.id);
            return [3
            /*break*/
            , 6];

          case 5:
            err_2 = _a.sent();
            console.error("error", err_2);
            return [3
            /*break*/
            , 6];

          case 6:
            return [4
            /*yield*/
            , conv.queryMessages({
              limit: 20
            })];

          case 7:
            histories = _a.sent();
            messages = [];
            res = histories.map(function (m) {
              return convertToChatMessage(m, _this.myself);
            });
            res.forEach(function (m) {
              if (m) {
                messages.push(m);
              }
            });
            return [2
            /*return*/
            , messages];
        }
      });
    });
  };

  ChatClient.prototype._sendTextMessageImpl = function (conv, text) {
    return __awaiter(this, void 0, Promise, function () {
      var msg, lm, attrs, m, err_3, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            msg = new TextChatMessageDto(ChatMessageDto.nextPendingMessageId(), MessageIOType.Sent, FHTDeviceType.Web, new Date(), text);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            lm = new TextMessage(text);
            attrs = {
              dt: FHTDeviceType.Web
            };
            lm.setAttributes(attrs);
            return [4
            /*yield*/
            , conv.send(lm)];

          case 2:
            m = _a.sent();
            msg.id = m.id;
            msg.timestamp = m.timestamp;
            return [3
            /*break*/
            , 4];

          case 3:
            err_3 = _a.sent();
            res = err_3;
            return [2
            /*return*/
            , this._markAsFailedMessages(msg, res)];

          case 4:
            return [2
            /*return*/
            , msg];
        }
      });
    });
  };

  ChatClient.prototype._sendBusinessEmojiMessageImpl = function (conv, emoji) {
    return __awaiter(this, void 0, Promise, function () {
      var attr, msg, lm, m, err_4, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            attr = {
              EMOTION_PATH_KEY: emoji,
              dt: FHTDeviceType.Web
            };
            msg = new RichCustomChatMessageDto(ChatMessageDto.nextPendingMessageId(), MessageIOType.Sent, FHTDeviceType.Web, new Date(), FhtLeancloudCustomMessageType.BusinessEmoji, attr, this.myself);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            lm = new CustomBizEmojiMessage(attr);
            return [4
            /*yield*/
            , conv.send(lm)];

          case 2:
            m = _a.sent();
            msg.id = m.id;
            msg.timestamp = m.timestamp;
            return [3
            /*break*/
            , 4];

          case 3:
            err_4 = _a.sent();
            console.warn("sendBusinessEmojiMessage failed:", err_4);
            res = err_4;
            msg.id = res.uid || msg.id;
            return [2
            /*return*/
            , this._markAsFailedMessages(msg, res)];

          case 4:
            return [2
            /*return*/
            , msg];
        }
      });
    });
  };

  ChatClient.prototype._sendImageMessageImpl = function (conv, imageUrl) {
    return __awaiter(this, void 0, Promise, function () {
      var formatedImgUrl, imageSize, msg, file, savedFile, lm, attrs, m, err_5, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assert(imageUrl, "imageUrl is falsy");
            formatedImgUrl = formatImageUrl(imageUrl, ImageSizeTypeEnum.Large);
            !IS_PROD && console.log("formatedimageurl", formatedImgUrl);
            return [4
            /*yield*/
            , getImageSize(formatedImgUrl)];

          case 1:
            imageSize = _a.sent();
            msg = new ImageChatMessageDto(ChatMessageDto.nextPendingMessageId(), MessageIOType.Sent, FHTDeviceType.Web, new Date(), formatedImgUrl, imageSize);
            _a.label = 2;

          case 2:
            _a.trys.push([2, 5,, 6]);

            file = AV.File.withURL("萌妹子", imageUrl);
            file.metaData("height", imageSize.height);
            file.metaData("width", imageSize.width);
            file.metaData("size", 1);
            return [4
            /*yield*/
            , file.save()];

          case 3:
            savedFile = _a.sent();
            lm = new ImageMessage(savedFile);
            attrs = {
              dt: FHTDeviceType.Web
            };
            lm.setAttributes(attrs);
            return [4
            /*yield*/
            , conv.send(lm, {
              receipt: true
            })];

          case 4:
            m = _a.sent();
            console.log("图片数据发送成功！", m);
            msg.id = m.id;
            msg.timestamp = m.timestamp;
            console.log("图片信息", "lm", lm, "file", file, "m", m);
            return [3
            /*break*/
            , 6];

          case 5:
            err_5 = _a.sent();
            console.warn("sendImageMessage failed:", err_5);
            res = err_5;
            msg.id = res.uid || msg.id;
            return [2
            /*return*/
            , this._markAsFailedMessages(msg, res)];

          case 6:
            return [2
            /*return*/
            , msg];
        }
      });
    });
  };

  ChatClient.prototype._markAsFailedMessages = function (msg, errorResult) {
    var status = [];

    if (errorResult.code === ErrorCode.MESSAGE_REJECTED_BY_APP) {
      if (errorResult.appCode === FhtAppErrorCode.FHT_BLOCKED_ERROR_CODE) {
        return [msg];
      } else if (errorResult.appCode === FhtAppErrorCode.FHT_CUSTOM_VALIDATION_ERROR_CODE) {
        status.push({
          Type: NotificationContentPartTypeEnum.String,
          Text: "消息格式不正确，未通过服务端验证",
          Id: 0,
          Key: ""
        });
      } else if (errorResult.appCode === FhtAppErrorCode.FHT_MESSAGE_LIMIT_REACHED_ERROR_CODE) {
        //No worry. Server will send another status message
        return [msg];
      } else if (errorResult.appCode === FhtAppErrorCode.FHT_TEMPORARY_CHAT_DISABLED_ERROR_CODE) {//leancloud node.js will send new status message so no need.
        // status.push({ Type: FhtContentPartType.String, Text: "对方未开启临时聊天" });
      }
    } else if (errorResult.code === ErrorCode.INVALID_MESSAGING_TARGET) {
      status.push({
        Type: NotificationContentPartTypeEnum.String,
        Text: "你不在该聊天中",
        Id: 0,
        Key: ""
      });
    }

    msg.failedReason = status.map(function (s) {
      return s.Text || "";
    }).join("");
    var errorMessage = new RichCustomChatMessageDto(ChatMessageDto.nextPendingMessageId(), MessageIOType.Status, FHTDeviceType.All, new Date(), FhtLeancloudCustomMessageType.ChatRoomStatus, {
      dt: FHTDeviceType.Web,
      Other: status
    }, this.myself);
    return [msg, errorMessage];
  };

  ChatClient.prototype.sendMessage = function (message) {
    return __awaiter(this, void 0, Promise, function () {
      var im, contact, conv;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.triggerLoadImIfNotAlreadyLoaded();
            return [4
            /*yield*/
            , this._imP];

          case 1:
            im = _a.sent();
            contact = message.to;
            assert(contact, "contact falsy");
            assert(contact.convId, "convId falsy");
            return [4
            /*yield*/
            , im.getConversation(contact.convId)];

          case 2:
            conv = _a.sent();
            assert(conv, "conv falsy");

            switch (message.type) {
              case "text":
                return [2
                /*return*/
                , this._sendTextMessageImpl(conv, message.text)];

              case "image":
                return [2
                /*return*/
                , this._sendImageMessageImpl(conv, message.imageUrl)];

              case "bizEmoji":
                return [2
                /*return*/
                , this._sendBusinessEmojiMessageImpl(conv, message.emoji)];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ChatClient._instanceCount = 0;
  return ChatClient;
}();

export { ChatClient };